import sanitizeHtml from "sanitize-html";

// Sanityzacja treści pochodzącej od (potencjalnie niezaufanego) nadawcy przed wstrzyknięciem
// w dangerouslySetInnerHTML. Dozwolone podstawowe formatowanie; wycięte skrypty, atrybuty on*,
// style oraz niebezpieczne schematy URL (javascript:, vbscript: itp.).
//
// UWAGA: pełny HTML maili renderujemy w sandboxowanym iframe (EmailViewer/Package). Ten helper
// dotyczy ścieżek, które wstrzykują treść bez iframe (plaintext, stopka, opis przekazania).
const BASE_OPTIONS: sanitizeHtml.IOptions = {
  allowedTags: [
    "p", "br", "b", "i", "u", "s", "strong", "em", "mark", "small", "sub", "sup",
    "ul", "ol", "li", "a", "img", "span", "div", "pre", "code", "blockquote",
    "h1", "h2", "h3", "h4", "h5", "h6",
    "table", "thead", "tbody", "tr", "td", "th",
  ],
  allowedAttributes: {
    a: ["href", "target", "rel"],
    img: ["src", "alt", "width", "height"],
    "*": ["class"],
  },
  allowedSchemes: ["http", "https", "mailto"],
  allowedSchemesByTag: {
    // dopuszczamy data: tylko dla obrazków (odszyfrowane obrazki wstawiane inline)
    img: ["http", "https", "data"],
  },
  // linki zawsze bezpieczne: nowe okno + rel bez wycieku referrera/opener
  transformTags: {
    a: sanitizeHtml.simpleTransform("a", {
      target: "_blank",
      rel: "noopener noreferrer",
    }),
  },
};

export const sanitizeUserHtml = (html?: string | null): string =>
  html ? sanitizeHtml(html, BASE_OPTIONS) : "";

/**
 * Wariant dla treści czytanej przez osoby spoza firmy (portal EBI): obrazki tylko wklejone (data:) — zewnętrzny adres
 * (piksel śledzący) zdradzałby obcemu serwerowi IP i chwilę otwarcia — i bez atrybutu class, bo globalne klasy
 * aplikacji pozwoliłyby zbudować z treści nakładkę udającą interfejs portalu.
 */
export const sanitizeStrictHtml = (html?: string | null): string =>
  html
    ? sanitizeHtml(html, {
        ...BASE_OPTIONS,
        allowedAttributes: {
          a: ["href", "target", "rel"],
          img: ["src", "alt", "width", "height"],
        },
        allowedSchemesByTag: { img: ["data"] },
      })
    : "";
